module.exports = __webpack_public_path__ + "static/media/no_ads_nov_2021_thumb.19d41c74.jpg";